
import { defineComponent } from 'vue'
import NavbarSection from "./NavbarSection.vue";

import LogoElem from "../pageElements/LogoElem.vue";

export default defineComponent({
    name: "NavSection",

    components:{
        NavbarSection,
        LogoElem
    },

    data(){
        return{
            isWindowScrolled: false,
            isNavExpand: false,
            mobilePage: false,

            navCloseDistance: 0,
            navCloseCalcDist: 0,
            throtNavCloseDist: 0,
        }
    },

    mounted(){

        // Nav - scrolled view
        window.addEventListener("scroll", () => {
            this.isWindowScrolled = window.scrollY > 0 ? true : false;
        });

        // Nav collapse on page resize &&
        // Check if the page is mobile (<= 768px)
        this.checkIfMobile();
        window.addEventListener("resize", () => {

            this.isNavExpand = false;
            this.checkIfMobile();

        });

        // Nav collapse when clicking outside the nav
        window.addEventListener("click", (e) =>{

            const innerNavElement = this.$refs.innerNav as HTMLElement;

            if (!innerNavElement || 
                (innerNavElement !== e.target &&
                !innerNavElement.contains(e.target as Node))){

                this.isNavExpand = false;
            }

        });

        // Throttle the mousemove border gradient animation
        document.addEventListener("mousemove", (e) => {

            if (!this.mobilePage) return;

            if (!this.throtNavCloseDist){
                this.throtNavCloseDist = setTimeout(() => {
                    this.navCloseDistCalc(e);
                    this.throtNavCloseDist = 0;
                }, 16); // 60+ FPS
            }

        });

    },

    methods:{

        checkIfMobile(){

            if (window.innerWidth <= 768){
                this.mobilePage = true;
            } else {
                this.mobilePage = false;
            }

        },

        navLogoScroll(){

            if (this.mobilePage) return;

            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });

        },

        toggleNav(e: MouseEvent){

            if (!this.mobilePage) return;

            // Check if the clicked element is the navCloseBtn
            const isCloseButton = 
                (this.$refs.navCloseBtn as HTMLElement).contains(e.target as Node);

            // Check if the clicked element is a nav-link
            const navLinks = document.querySelectorAll(".nav-link");
            let isNavLink = false;
                            
            navLinks.forEach((navLink) => {
                if (navLink.contains(e.target as Node)){
                    isNavLink = true;
                }
            });

            // Toggle Nav
            if (this.isNavExpand && (isCloseButton || isNavLink)){
                this.isNavExpand = false;
            } else if (!this.isNavExpand){
                this.isNavExpand = true;
            }

        },

        navCloseDistCalc(e: MouseEvent){
            
            if (!this.mobilePage) return;
            
            const innerNav = this.$refs.innerNav as HTMLElement;
            if (!innerNav || !e.target) return;

            if (e.target === innerNav ||
                innerNav.contains(e.target as Node)){
                        
                // Get the close button position data
                const closeBtnRect = (this.$refs.navCloseBtn as HTMLElement).getBoundingClientRect();
                const innerNavRect = innerNav.getBoundingClientRect();

                // Distance
                const dx = Math.max(0, e.clientX < closeBtnRect.left 
                    ? closeBtnRect.left - e.clientX 
                    : e.clientX - closeBtnRect.right);
                const dy = Math.max(0, e.clientY < closeBtnRect.top 
                    ? closeBtnRect.top - e.clientY 
                    : e.clientY - closeBtnRect.bottom);

                // Calculate the distance
                const distToCloseBtn = Math.sqrt(dx * dx + dy * dy);
                const maxDist = Math.hypot(innerNavRect.width, innerNavRect.height);

                // Ensure the distance is within bounds
                this.navCloseDistance = Math.max(0, 
                    Math.min((100 * (1 - (distToCloseBtn / maxDist))), 100)
                );
                    
                this.navCloseCalcDist = 
                    50 - (5/9) * (this.navCloseDistance - 100);

            } else {
                this.navCloseDistance = 0;
                this.navCloseCalcDist = 0;
            }
            
        }

    },

    watch:{
        navCloseCalcDist(newVal){
            if (newVal > 0){
                document.body.style.setProperty("--navDistColor", 
                    `${this.navCloseDistance * 0.8}%`);
                document.body.style.setProperty("--navDistBorder", 
                    `${newVal}%`);
            } else {
                document.body.style.setProperty("--navDistColor", "0");
                document.body.style.setProperty("--navDistBorder", "100%");
            }
        }
    }

});
